import router from '@/router'

export default function navigateBack(step = -1) {
  // 在 PC 适配（iframe）环境下，初次加载深链接时，history.length 可能 > 1，
  // 但无法有效返回上一页。此处放宽阈值，确保能回到首页。
  const isInIframe = window.top !== window
  const historyLen = window.history.length || 0
  const minimalBackDepth = isInIframe ? 2 : 1

  if (historyLen <= minimalBackDepth) {
    router.push('/')
    return false
  }
  router.go(step)
}
